module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "custom-file"
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "disabled": _vm.disabled,
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        _vm.sendAmazon($event.target.files[0])
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-file-control"
  }, [_vm._v(_vm._s(_vm.placeholder))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06ac96c9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/regularInputFile.vue
// module id = 827
// module chunks = 1